import React from 'react';
import { Typography } from '@material-ui/core';


const HomePage = () => {

    return (
        <Typography variant="h1" align="center">
            <h1 className="bg-light">Learning Redux &#128640;</h1>

        </Typography >

    );
};

export default HomePage;